<template>
  <div class="ja-home">
    <JaHomeHeader :userName="userName" />
    <div class="button-wrapper">
      <LargeButton
        class="large-button"
        @click="moveContent()"
        :title="CONTENT_BUTTON_TITLE"
        :description="CONTENT_BUTTON_DESCRIPTION"
        :image="CONTENT_BUTTON_IMAGE"
        :alt="'content button image'"
      />
      <LargeButton
        class="large-button"
        @click="moveStreamGroup()"
        :title="STREAM_GROUP_BUTTON_TITLE"
        :description="STREAM_GROUP_BUTTON_DESCRIPTION"
        :image="STREAM_GROUP_BUTTON_IMAGE"
        :alt="'stream group button image'"
      />
      <div class="manual-link">
        <router-link to="/ja/manualLinks">困ったときはこちら</router-link>
      </div>
      <div class="notice-area">
        <img
          :src="require(`@/assets/images/${NOTICE_ICON}`)"
          alt="お知らせロゴ"
          class="notice-logo"
        />
        お知らせ
      </div>
      <JaNotice class="notification-area" />
    </div>
    <div class="footer d-flex p-fixed items-center justify-center">
      {{ COPYRIGHT_STR }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import LargeButton from '@/components/common/LargeButton.vue';
import { COPYRIGHT_STR } from '@/composable/constant_common';
import JaHomeHeader from './JaHomeHeader.vue';
import JaNotice from './JaNotice.vue';

// コンテンツ管理画面遷移ボタン用ロゴ
const CONTENT_BUTTON_IMAGE = require('@/assets/images/ContentButton.png');
// 配信グループ管理画面遷移ボタン用ロゴ
const STREAM_GROUP_BUTTON_IMAGE = require('@/assets/images/StreamGroupButton.png');

// お知らせロゴ
const NOTICE_ICON = 'IconNotice.png';

// 配信グループ管理画面遷移ボタン用タイトル
const STREAM_GROUP_BUTTON_TITLE = '配信グループの管理';

// 配信グループ管理画面遷移ボタン用概要
const STREAM_GROUP_BUTTON_DESCRIPTION = '配信するコンテンツや順番などを管理します';

// コンテンツ管理画面遷移ボタン用タイトル
const CONTENT_BUTTON_TITLE = 'コンテンツの管理';

// コンテンツ管理画面遷移ボタン用概要
const CONTENT_BUTTON_DESCRIPTION = 'メディアを選択して配信コンテンツを作成します';

const store = useStore();
const router = useRouter();

/**
 * ユーザStore参照
 */
const userName = computed(() => store.getters['userInformation/getUserName']);

/**
 * コンテンツ管理画面遷移処理
 */
const moveContent = () => {
  router.push('/ja/content');
};

/**
 * 配信グループ管理画面遷移処理
 */
const moveStreamGroup = () => {
  router.push('/ja/streamGroup');
};
</script>

<style scoped>
.large-button {
  width: 100%;
  margin: 2rem auto;
}
.button-wrapper {
  padding-top: 8rem;
  padding-bottom: 4rem;
  width: 90%;
}
@media screen and (min-width: 840px) {
  .button-wrapper {
    width: 100%;
  }
}
.large-button :deep(.button) {
  width: 100%;
  max-width: 840px;
}
.manual-link {
  font-size: 2rem;
  text-decoration: underline;
  text-align: center;
}
.manual-link a {
  color: #444444;
}
.notice-area {
  display: flex;
  align-items: center;
  color: #21963b;
  font-size: 14px;
  font-weight: 700;
  width: 90%;
  margin: 1.9rem 1.5rem 1.5rem 1.5rem;
}
.notice-logo {
  width: 23px;
  height: auto;
  margin-right: 10px;
}
.notification-area {
  background-color: #eaf7ed;
  border-radius: 1rem;
  margin: 1.5rem;
}
.ja-home {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer {
  bottom: 0;
  left: 0;
  right: 0;
  height: 5vh;
  height: 5dvh;
  width: 100vw;
  background: #fff;
  border: 1px #eee solid;
  z-index: 2;
  font-size: 1.2rem;
}
</style>
